// 표 셀의 "실제로 표시되는 값 소스" 종류를 renderTableCell 우선순위와 동일하게 판정하는 순수 함수.
//
// renderTableCell(RenderTemplate.tsx)의 값소스 우선순위:
//   content > (비어있지 않은)text > aggregate > compute > binding
// 이 파일은 그중 "데이터 값 소스"(aggregate/compute/binding)만 판별한다. content 노드와 비어있지
// 않은 정적 text는 값 소스가 아니므로 null(내부 노드는 노드 배지를 받고, 정적 text는 값 소스를 가림).
// admin BindingBadgeOverlay(셀 배지 대상 수집)와 렌더 엔진(renderTableCell 분기)이 같은 판정을 공유해
// 배지/렌더가 어긋나지 않게 한다.

import type { TableCell } from '@safetyhub/shared';

/** 셀에 표시되는 값 소스 종류(데이터 값 소스만 — content/정적 text는 null). */
export type CellSourceKind = 'binding' | 'compute' | 'aggregate';

/**
 * 셀에 "실제로 표시되는" 값 소스 종류. renderTableCell 우선순위와 일치.
 *  - content 있음(길이>0): 내부 노드가 노드 배지를 받으므로 셀 값 소스 없음(null).
 *  - text가 비어있지 않으면: 정적 텍스트가 값 소스를 가리므로 null.
 *    (빈 text('')는 값 소스가 있으면 fallback되므로 값 소스로 취급 — renderTableCell과 동일.)
 *  - 그 외: aggregate > compute > binding.
 */
export function effectiveCellSourceKind(cell: TableCell): CellSourceKind | null {
  if (cell.content && cell.content.length > 0) return null;
  const hasValueSource = Boolean(cell.binding || cell.compute || cell.aggregate);
  const textWins = cell.text !== undefined && !(cell.text === '' && hasValueSource);
  if (textWins) return null;
  if (cell.aggregate) return 'aggregate';
  if (cell.compute) return 'compute';
  if (cell.binding) return 'binding';
  return null;
}
